import { render, staticRenderFns } from "./Autotransportes.vue?vue&type=template&id=f98f361c&scoped=true&"
import script from "./Autotransportes.vue?vue&type=script&lang=js&"
export * from "./Autotransportes.vue?vue&type=script&lang=js&"
import style0 from "./Autotransportes.vue?vue&type=style&index=0&id=f98f361c&lang=scss&scoped=true&"
import style1 from "./Autotransportes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f361c",
  null
  
)

export default component.exports